<template>
   	<div class="tab-body"  style="margin-top:-15px">
        <iframe id="template-iframe" ref="iframe" :src="src" height="100%"  scrolling="yes"></iframe>
    </div>
 
</template>

<script>

export default {
  name: "adv",
  components: {
 
  },
  data() {
    return {
     src: "/static/adv/index.html"
    };
  },
  methods: {
    //打开弹框
    open(parameter,  title, disabled, size) {
      this.$nextTick(() => {
        this.init();
      });
    }, 
    //关闭弹框
    close() {
   
      this.$refs.popup.close();
    },
    init() {
   
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>
